import styled from "@emotion/styled";
import { FilterByTags } from "@kaltura/mediaspace-shared-types";
import Filter from "./Filter";
import { FiltersValues } from "../bubbles/Bubbles";

export interface FiltersProps {
    onFilterChange: (param: string, values: string[]) => void;
    filters?: FilterByTags[];
    values?: FiltersValues;
}

const StyledFilters = styled("div")(({ theme }) => ({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginTop: theme.spacing(1),
    gap: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
        marginTop: 0,
    },
}));

const StyledFilter = styled(Filter)(({ theme }) => ({
    marginTop: theme.spacing(1),
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
        marginTop: 0,
        flexGrow: 0,
        maxWidth: 112,
    },
    [theme.breakpoints.up("md")]: {
        maxWidth: 168,
    },
}));

/**
 * Sessions Filter Bar Filters
 */
export function Filters(props: FiltersProps) {
    const { filters = [], values = {}, onFilterChange } = props;

    // only show filters with options in them
    const visibleFilters = filters
        .filter((item): boolean => item !== null)
        .filter((optionFilters: FilterByTags) => optionFilters.tags.length > 0);

    return (
        <StyledFilters className="kms-ds-agenda-filters">
            {visibleFilters.map((optionFilters: FilterByTags) => {
                const { id, label, allValuesElement, tags } = optionFilters;
                const filterLabel = values[id]?.length > 0 ? label : allValuesElement || label;
                return (
                    <StyledFilter
                        className="kms-ds-agenda-filter"
                        key={id}
                        param={id}
                        label={filterLabel}
                        options={tags}
                        values={values[id]}
                        allValuesOption={allValuesElement}
                        onChange={onFilterChange}
                        countSelected={!!allValuesElement}
                    />
                );
            })}
        </StyledFilters>
    );
}

export default Filters;
